export const MESSAGE_SENDER = 'MESSAGE_SENDER';

export const ROLES = [{ role: MESSAGE_SENDER, label: 'Send messages' }];
